import script from "./AppCooperation.vue?vue&type=script&setup=true&lang=js"
export * from "./AppCooperation.vue?vue&type=script&setup=true&lang=js"

import "./AppCooperation.vue?vue&type=style&index=0&id=0d81bb80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d81bb80"]])

export default __exports__